import { StackingRootContext } from '@tableau/widgets';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { getAppStore } from '~src/app/AppStore';
import { VizService, VizServiceContext } from '~src/app/spaces/VizSpace/VizService';

import { AppRootStateConnector } from '../components/AppRootStateConnector';

export function mountReactApp(vizServiceInstance: VizService) {
    const stackingRoot = document.getElementById('app-root');
    ReactDOM.render(
        <StackingRootContext.Provider value={stackingRoot}>
            <Provider store={getAppStore()}>
              {/* TODO- TFS 1282587: Remove this context from mountReactApp() and move it to RootSpace TFS along with 1282587*/}
              <VizServiceContext.Provider value={vizServiceInstance}>
                <AppRootStateConnector/>
              </VizServiceContext.Provider>
            </Provider>
        </StackingRootContext.Provider>,
        stackingRoot
    );
}
